require('./bootstrap');

let $ = window.jQuery;

ace.config.set("basePath", "//cdnjs.cloudflare.com/ajax/libs/ace/1.4.12/");

(function($) {
    function makePostRequest(url, data, method, target) {
        var jForm = $('<form style="display: none"></form>');
        jForm.attr('action', url);
        jForm.attr('method', 'post');
        if (target)
            jForm.attr('target', target);

        let token = document.head.querySelector('meta[name="csrf-token"]');
        data = {...data};
        data._token = token.content;
        data._method = method || "POST";

        for (let name in data) if (data.hasOwnProperty(name)) {
            let val = data[name];
            let jInput = $("<input>");
            jInput.attr('name', name);
            jInput.attr('value', val);
            jForm.append(jInput);
        }
        $("body").append(jForm);
        jForm.submit();
    }
    window.makePostRequest = makePostRequest;

    $.fn.send = function(url, method, target){
        let data = this.data();
        let params = {
            //_token: token.content,
            //_method: method || this.data('method') || "POST"
        };
        for (let k in data) if (data.hasOwnProperty(k)) {
            if (k.indexOf("param_") === 0) {
                let key = k.split("_", 2)[1];
                params[key] = data[k];
            }
        }
        makePostRequest(url || $(this).data('url') || this.attr("href"), params, method || this.data('method'), target || this.attr("target"));
    };

    $.fn.useForm = function() {
        this.filter("a").on("click", function($event){
            $event.preventDefault();
            $(this).send();
        });
        return this;
    };

    $.fn.useConfirm = function() {
        this.filter("a").on("click", function($event){
            $event.preventDefault();
            $event.stopImmediatePropagation();
            window.confirmRequest($(this).data('confirm'), 'Подтверждение', /*'Confirm',*/ 'OK', 'Отмена', /*'Cancel',*/ () => {
                $(this).send();
            });
        });
        return this;
    };

    var ace_editor_element = document.getElementsByClassName("ace_editor");
    // For each ace editor element on the page
    for (var i = 0; i < ace_editor_element.length; i++) {
        // Create an ace editor instance
        var ace_editor = ace.edit(ace_editor_element[i].id);
    	// Get the corresponding text area associated with the ace editor
	    var ace_editor_textarea = document.getElementById(ace_editor_element[i].id + '_textarea');
        if(ace_editor_element[i].getAttribute('data-theme')){
        	ace_editor.setTheme("ace/theme/" + ace_editor_element[i].getAttribute('data-theme'));
        }
        if(ace_editor_element[i].getAttribute('data-language')){
        	ace_editor.getSession().setMode("ace/mode/" + ace_editor_element[i].getAttribute('data-language'));
        }
        ace_editor.setFontSize(14);
        ace_editor.on('change', function(event, el) {
        	ace_editor_id = el.container.id;
    	    ace_editor_textarea = document.getElementById(ace_editor_id + '_textarea');
    	    ace_editor_instance = ace.edit(ace_editor_id);
    	    ace_editor_textarea.value = ace_editor_instance.getValue();
        });
    }

}($));

function escapeHtml(text) {
    var map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, function(m) { return map[m]; });
}
window.escapeHtml = escapeHtml;

const areTheNumbersAlmostEqual = (num1, num2) => {
    return Math.abs( num1 - num2 ) < Number.EPSILON;
}
window.areTheNumbersAlmostEqual = areTheNumbersAlmostEqual;

window.confirmRequest = function(message, title, ok, cancel, callback) {
    window.bootbox.confirm({
        title: title,
        message: message,
        buttons: {
            confirm: {
                label: ok,
                className: 'btn-danger btn-sm btn-wide'
            },
            cancel: {
                label: cancel,
                className: 'btn-default btn-sm btn-wide'
            }
        },
        callback: function (result) {
            if (result) {
                callback();
            }
        }
    });
};

window.onAjaxFail = function(jqXHR, textStatus, errorThrown) {
    jQuery('body').LoadingOverlay('hide');
    console.log(jqXHR, textStatus, errorThrown);
    if (jqXHR.responseJSON) {
        var res = jqXHR.responseJSON;
        // bootbox.alert({
        //     title: "Error",
        //     message: res.message || res.error,
        //     /*className: message[0],*/
        //     buttons: { ok : {
        //         label: 'OK',
        //         className: 'btn btn-success',
        //     }}
        // });
        toastr.error(res.message || res.error);
    }
};

$(function() {
    let token = document.head.querySelector('meta[name="csrf-token"]');
    if (token) {
        window.$.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': token.content
            }
        });
    } else {
        console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
    }

    $('a[data-confirm]').useConfirm();
    $('a[data-method]').useForm();
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-toggle="popover"]').popover();
    $('[data-style="large-switch"]').bootstrapSwitch();
    $('form[data-form="filter"] [data-refresh="1"]').on('change', function ($event){
        $(this).closest('form').submit();
    });
    $('.select2').select2();

    $('textarea.editor').each(function(index, value){
        var height = $(this).data('editor-height');
        let editor = CKEDITOR.replace(value, {
            language: 'ru',
            //enterMode: CKEDITOR.ENTER_BR,
            //width: width,
            height: height,

            skin: "moono",
            //toolbar: tool,

            //contentsCss: settings.baseUrl + '/css/content.css'
            //bodyClass: 'page tree-page'

            filebrowserUploadUrl: '/ckfinder/connector?command=QuickUpload&type=Images&responseType=json&currentFolder=/news/' + moment().format('YYYY/MM/DD') + '/',

            allowedContent: {
                script: true,
                div: true,
                $1: {
                    // This will set the default set of elements
                    elements: CKEDITOR.dtd,
                    attributes: true,
                    styles: true,
                    classes: true
                }
            }

        });
        CKFinder.setupCKEditor(editor);
    });

    $('[role=tablist] a[data-locale]').on("click", function ($event){
        $event.preventDefault();

        var locale = $(this).data('locale');
        var $tablist = $(this).closest('[role=tablist]');
        $tablist.find('a[data-locale]').removeClass('active');
        $tablist.find('a[data-locale=' + locale + ']').addClass('active');

        $('[data-locale]:not(.nav-link)').hide();
        $('[data-locale=' + locale + ']:not(.nav-link)').show();

        $('[data-xlocale]').show();
        $('[data-xlocale=' + locale + ']').hide();

        $('.select-i18n option').each(function(){
            $(this).text($(this).data('label-' + locale));
        });

        localStorage.setItem('locale', locale);
    });

    let locale = localStorage.getItem('locale');
    if (locale)
        $('[role=tablist] a[data-locale="' + locale + '"]').trigger('click');
    else
        $('[role=tablist] a[data-locale]').eq(0).trigger('click');
});
